import ListCartHeaderInterface from '../interfaces/ListCartHeaderInterface';
import CreateListProduct from './CreateListProduct';
import RenderInterface from '../interfaces/RenderInterface';

/**
 * Create Html element products list
 */
export default class RenderListProducts {
  public static execute(
    render: RenderInterface,
    element: HTMLElement,
    templateElement: HTMLElement,
    deleteProduct: Function,
    data: ListCartHeaderInterface
  ) {
    switch (render.type) {
      case 'createList':
        // Create list
        CreateListProduct.execute(
          data,
          element,
          templateElement,
          deleteProduct
        );
        break;
    }
  }
}
